import { useEffect, useMemo, useState } from 'react';
import { observer } from 'mobx-react-lite';
import { Segmented, Tabs } from 'antd';
import { SVGPureIcon } from '@/ui';
import Code from './components/code';

const CardSearch = observer((props) => {
  const {
    results,
    event,
    mcpStore,
    currentDark,
    callbackTabs,
  } = props;

  const [alignValue, setAlignValue] = useState('搜索结果');
  const [queryList, setQueryList] = useState([]);
  const [toolsCode, setToolsCode] = useState('');

  const tabList = useMemo(() => {
    const list = ['搜索结果'];
    const text = event?.querys || event?.text || event?.detail?.querys; // 前两2个是老的数据格式
    if (text) {
      list.push('拆词');
      setQueryList(text.split('|'))
    }
    const paramsText = mcpStore.getNodeParamsText(event);
    if (paramsText) {
      list.push('工具参数');
      setToolsCode(paramsText)
    }
    return list;
  }, [])

  const onTabChange = (value) => {
    setAlignValue(value);
    callbackTabs && callbackTabs(value);
  }

  const format = (tool_request, tool_respond) => {
    const result = [];
    if(tool_request){
      result.push(`${event.tool} 输入:\n`);
      try{
        result.push(JSON.stringify(JSON.parse(tool_request), null, '\t'))
      } catch(e){
        result.push(tool_request);
      }
      result.push("\n");
    }
    if(tool_respond){
      result.push(`${event.tool} 输出:\n`);
      try{
        result.push(JSON.stringify(JSON.parse(tool_respond), null, '\t'))
      } catch(e){
        result.push(tool_respond);
      }
    }
    return result.join("\n");
  }

  return (
    <>
      <div className='pt-16px pb-8px pl-24px tabs'>
        <Segmented
          value={alignValue}
          onChange={onTabChange}
          options={tabList}
        />
      </div>
      
      <div className={[
        "px-10px mx-4px mb-16px mt-10px flex-grow overflow-x-hidden overflow-y-auto",
        currentDark ? 'scrollbar-dark' : 'scrollbar']}>
        {
          alignValue === '搜索结果' ? (
            <>
              <div className="mt-10px mb-16px mx-10px">本次搜索已进行重排序，共获得 {event?.detail?.site_num || 0} 个信源、共获得 {results.length} 个搜索结果：</div>
              <ul className="">
              {
                results && results.map((item, index) => {
                  const {
                    title,
                    summary_large,
                    url,
                    site_name,
                    favicon,
                    date,
                  } = item;

                  return (
                    <li className="px-10px hover:bg-[#f7f7f7] rounded-8px" key={`page_${index}`}>
                      <a className="block text-14px leading-20px !text-black hover:text-black py-16px" href={url} target='_blank'>
                        <div className="flex flex-row items-center mb-8px">
                          <div className="w-20px h-20px rounded-full mr-10px overflow-hidden">
                            <img width="20" height="20" src={favicon || 'https://p3.ssl.qhimg.com/t110b9a9301e7123672fdc63a36.png'} />
                          </div>
                          <div className='text-14px leading-16px'>{site_name}</div>
                        </div>
                        <h3 className="font-normal line-clamp-1 text-12px leading-20px">{title}</h3>
                        <p className="line-clamp-2 text-12px leading-20px text-black text-opacity-50 mb-0">
                          {date ? date : ''} {summary_large}
                        </p>
                        <p className="line-clamp-1 text-12px leading-20px text-black text-opacity-50 text mb-0">{url}</p>
                      </a>
                      <div className="h-1px bg-black bg-opacity-9"></div>
                    </li>
                  )
                })
              }
              </ul>
            </>
          ) : null
        }

        {
          alignValue === '拆词' ? (
            <div className="text-13px text-black leading-18px">
              <div className="pl-12px">根据原问题拆解了 {queryList.length} 个搜索关键词</div>
              <div className="bg-white rounded-12px p-12px pb-4px whitespace-pre-wrap text-13px text-black leading-22px break-all">
                {
                  queryList.map((keyWord, index) => {
                    return (
                      <div
                        key={`queryList-${index}`}
                        className='flex gap-8px mb-8px h-18px items-center'
                      >
                        <SVGPureIcon 
                          name="mcp-search"
                          size={16}
                        />
                        <div className='text-13px text-black w-0 flex-grow line-clamp-1' title={keyWord}>
                          {keyWord}
                        </div>
                      </div>
                    )
                  })
                }
              </div>
          </div>
          ) : null
        }

        {
          alignValue === '工具参数' ? (
            <div className="p-12px whitespace-pre-wrap text-13px text-black leading-22px break-all">
              <Code
                data={'```json\n' + mcpStore.getNodeParamsText(event)?.trim() + '\n```'}
                className="whitespace-pre-wrap"
                syntaxClassName="language-json"
                light={false}
                showLineNumbers={true}
              />
              {/* {mcpStore.getNodeParamsText(event)} */}
            </div>
          ) : null
        }
      </div>
    </>
  )
});

export default CardSearch;